// extracted by mini-css-extract-plugin
export default {"checkbox":"NB97Nq"};